import React from 'react';
import ReactDOM from 'react-dom/client';
import ChatApp from './Chatbot';

const renderChatbot = (elementId, props) => {
    const container = document.getElementById(elementId);
    if (container) {
        const root = ReactDOM.createRoot(container);
        root.render(<ChatApp {...props} />);
    } else {
        console.error(`Element with ID '${elementId}' not found.`);
    }
};

window.initChatbot = renderChatbot;